import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { empty } from 'rxjs/Observer';
import { TokenStorage } from '../../../storages/token.storage';
import { MessageWithTextPopup } from '../../modal-window/message-with-text-popup/message-with-text-popup.component';
import { LoggingService } from '../../../services/logging.service';


const apiServer = environment.apiServer;


@Injectable()
export class FileImportExportService {
  spinner: NgxSpinnerService;
  http: HttpClient;
  apiControl: string;
  downloadFileName: string;
  dataSetExportImportTable: any;
  token: TokenStorage;
  messageWithTextPopup: MessageWithTextPopup;

  constructor(_token: TokenStorage, private loggingService: LoggingService) { 
    this.token = _token;
    this.messageWithTextPopup = new MessageWithTextPopup()
  }

  onImport(event) {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Services.FileImportExportService.onImport', null, 'Import started');
    
    let fileToUpload: File = null;
    const onImportField = $('#onImportField');
    const selectedValueComponent = $('#selectedValueList');

    this.spinner.show();
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      fileToUpload = fileList[0];

      const endpoint = apiServer + this.apiControl + "/import";
      const formData: FormData = new FormData();
      formData.append('fileKey', fileToUpload, fileToUpload.name);

      const myHeaders = new HttpHeaders().set('Access-Control-Allow-Origin', 'origin-list');

      return new Promise((resolve, reject) => {
        this.http.put<any>(endpoint, formData, { headers: myHeaders }).subscribe(resp => {
          this.spinner.hide();
          if(resp == empty || resp == null){
            $('#downloadErrorModal').show();
            this.loggingService.logError(_xid, 'App.Services.FileImportExportService.onImport', new Error('Empty response'), null, 'Import failed - empty response');
            reject(new Error('Empty response'));
            return;
          } else if (resp.message != empty && resp.message != null) {
            let header = resp.error ? 'Некорректные данные' : 'Выполнено';
            this.messageWithTextPopup.show(header, resp.message)
          }
          

          this.dataSetExportImportTable = resp.data;
          this.dataSetExportImportTable.recordsTotal = resp.recordsTotal,
            this.dataSetExportImportTable.recordsFiltered = resp.recordsFiltered,
          selectedValueComponent.val('');
          onImportField.val('');
          this.loggingService.logFinish(_xid, 'App.Services.FileImportExportService.onImport', null, 'Import completed');
          resolve(this.dataSetExportImportTable);
        }, error => {
          $('#downloadErrorModal').show();
          this.spinner.hide();
          onImportField.val('');
          this.loggingService.logError(_xid, 'App.Services.FileImportExportService.onImport', error, null, 'Import failed');
          reject(error);
        });
      });
    } else {
      $('#downloadErrorModal').show();
      this.spinner.hide();
      onImportField.val('');
      this.loggingService.logError(_xid, 'App.Services.FileImportExportService.onImport', new Error('No files selected'), null, 'Import failed - no files');
      return Promise.reject(new Error('No files selected'));
    }
  }

  fileExportExample(event) {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Services.FileImportExportService.fileExportExample', null, 'Export example started');
    
    this.spinner.show();
    const endpoint = apiServer + this.apiControl + "/exportExample";
    
    this.http.get(endpoint, {
      responseType: 'arraybuffer'
    }).subscribe(resp => {
      this.downLoadFile(resp, "application/ms-excel")
      this.spinner.hide();
      this.loggingService.logFinish(_xid, 'App.Services.FileImportExportService.fileExportExample', null, 'Export example completed');
    }, error => {
      this.spinner.hide();
      this.loggingService.logError(_xid, 'App.Services.FileImportExportService.fileExportExample', error, null, 'Export example failed');
    });
  }

  public fileExport() {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Services.FileImportExportService.fileExport', null, 'Export started');
    
    this.spinner.show();
    console.log(this.apiControl);
    const endpoint = apiServer + this.apiControl + "/export";
    
    this.http.get(endpoint, {
      responseType: 'arraybuffer'
    }).subscribe(resp => {
      this.downLoadFile(resp, "application/ms-excel")
      this.spinner.hide();
      this.loggingService.logFinish(_xid, 'App.Services.FileImportExportService.fileExport', null, 'Export completed');
    }, error => {
      this.spinner.hide();
      this.loggingService.logError(_xid, 'App.Services.FileImportExportService.fileExport', error, null, 'Export failed');
    });
  }

  downLoadFile(data: any, type: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Services.FileImportExportService.downLoadFile', null, 'Download file started');
      
      let blob = new Blob([data], { type: type });
      let url = window.URL.createObjectURL(blob);

      var anchor = document.createElement("a");
      anchor.download = this.downloadFileName;
      anchor.href = url;
      anchor.click();
      
      this.loggingService.logFinish(_xid, 'App.Services.FileImportExportService.downLoadFile', null, 'Download file completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Services.FileImportExportService.downLoadFile', _error, null, 'Download file failed');
      throw _error;
    }
  }

  updateVisibilytyFieldFromeRole() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Services.FileImportExportService.updateVisibilytyFieldFromeRole', null, 'Update visibility from role started');
      
      let person = this.token.getRole();

      $('#fileExportButton').hide();
      $('#fileImportButton').hide();
      if (person.includes("administrator")) {
        $('#fileExportButton').show();
        $('#fileImportButton').show();
      }
      
      this.loggingService.logFinish(_xid, 'App.Services.FileImportExportService.updateVisibilytyFieldFromeRole', null, 'Update visibility from role completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Services.FileImportExportService.updateVisibilytyFieldFromeRole', _error, null, 'Update visibility from role failed');
      throw _error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/service/file-import-export.service.ts